/// <amd-module name="Artifacts/PackageRecycleBin/redux/Sagas" />
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  IEmptyRecycleBinPayload,
  IInitLoadPayload,
  PackageRecycleBinActions as HubActions,
  PackageRecycleBinActionTypes as HubActionTypes,
} from "Artifacts/PackageRecycleBin/redux/Actions";
import * as Res from "Artifacts/PackageRecycleBin/Resources";
import { PackageRecycleBinService } from "Artifacts/PackageRecycleBin/services/PackageRecycleBinService";
import { call, getContext, put, takeEvery } from "Artifacts/Root/Saga";
import { SagaIterator } from "redux-saga";
import { ActionWithPayload } from "redux/Utils/ActionHelper";
import { announce } from "VSS/Core/Util/Accessibility";
import { IVssPageContext } from "VSS/Platform/Context";

export function* rootSaga(): SagaIterator {
  yield takeEvery(HubActionTypes.InitLoad, initializeHubData);
  yield takeEvery(HubActionTypes.EmptyRecycleBin, emptyRecycleBin);
}

export function* initializeHubData(
  action: ActionWithPayload<HubActionTypes.InitLoad, IInitLoadPayload>,
): SagaIterator {
  try {
    const { feed } = action.payload;
    announce(Res.RecycleBin_AnnounceLoadStart);

    yield put(HubActions.loadStarted());

    const pageContext: IVssPageContext = (yield getContext("pageContext")) as any;
    const packageRecycleBinService: PackageRecycleBinService = pageContext.getService(
      "IPackageRecycleBinService",
    );
    const initialData = (yield call(
      [packageRecycleBinService, packageRecycleBinService.getRecycleBinPackageVersions],
      pageContext,
      feed,
    )) as any;

    announce(Res.RecycleBin_AnnounceLoadSuccess);
    yield put(HubActions.loadCompleted(initialData));
  } catch (error) {
    announce(Res.RecycleBin_AnnounceLoadError);
    yield put(HubActions.loadFailed(error.message));
  }
}

export function* emptyRecycleBin(
  action: ActionWithPayload<HubActionTypes, IEmptyRecycleBinPayload>,
): SagaIterator {
  try {
    const { feed, onSuccessCallback } = action.payload;
    announce(Res.EmptyRecycleBin_AnnounceStart);
    yield put(HubActions.emptyRecycleBinStarted());

    const pageContext: IVssPageContext = (yield getContext("pageContext")) as any;
    const packageRecycleBinService: PackageRecycleBinService = pageContext.getService(
      "IPackageRecycleBinService",
    );
    const response =
      ((yield call(
        [packageRecycleBinService, packageRecycleBinService.emptyRecycleBin],
        pageContext,
        feed,
      )) as any) || "";

    announce(Res.EmptyRecycleBin_AnnounceSuccess);
    yield put(HubActions.emptyRecycleBinCompleted(response));
    yield call(onSuccessCallback);
  } catch (error) {
    announce(Res.EmptyRecycleBin_AnnounceError);
    const errorMessage = error.serverError.Message || error.message;
    yield put(HubActions.emptyRecycleBinFailed(errorMessage));
  }
}
